import React, { useState, useCallback } from "react";
import { CardContainer } from "./CardContainer";
import { HandContainerProps } from "./types";

export const HandContainer = ({ hand, onSelect }: HandContainerProps) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const handleCardClick = useCallback(
    (hexagenUid: string) => {
      onSelect(hexagenUid);
    },
    [onSelect]
  );

  if (!hand || hand.length === 0) return null;

  const cardCount = hand.length;
  const maxRotation = 15;
  const rotationStep = cardCount > 1 ? (maxRotation * 2) / (cardCount - 1) : 0;
  const startRotation = -maxRotation;

  const cardWidth = 120;
  const cardHeight = 160;
  const overlap = 0.6;
  const totalWidth = cardWidth + (cardCount - 1) * cardWidth * overlap;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 h-[200px] pointer-events-none z-[10001]"
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="relative w-full h-full flex justify-center items-end">
        <div
          className="relative"
          style={{
            width: `${totalWidth}px`,
            height: `${cardHeight}px`,
            marginBottom: "-40px",
          }}
        >
          {hand.map((hexagenUid, index) => {
            const rotation = startRotation + index * rotationStep;
            const yOffset = Math.abs(rotation) * 0.5;

            const isHovered = hoveredIndex === index;
            const isNeighbor =
              hoveredIndex !== null && Math.abs(hoveredIndex - index) === 1;

            let translateX = 0;
            if (hoveredIndex !== null) {
              if (index < hoveredIndex) {
                translateX = isNeighbor ? -20 : -10;
              } else if (index > hoveredIndex) {
                translateX = isNeighbor ? 20 : 10;
              }
            }

            return (
              <div
                key={hexagenUid}
                className="absolute pointer-events-auto"
                style={
                  {
                    "--rotation": isHovered ? "0deg" : `${rotation}deg`,
                    width: `${cardWidth}px`,
                    height: `${cardHeight}px`,
                    left: `${index * cardWidth * overlap}px`,
                    bottom: isHovered ? `${yOffset + 70}px` : `${yOffset}px`,
                    transform: `translateX(${translateX}px) rotate(${
                      isHovered ? 0 : rotation
                    }deg)`,
                    transformOrigin: "bottom center",
                    zIndex: isHovered ? 100 : index,
                    transition: "transform 0.3s ease, bottom 0.3s ease",
                    willChange: "transform, bottom",
                  } as React.CSSProperties
                }
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCardClick(hexagenUid);
                }}
              >
                <div
                  className="w-full h-full"
                  style={{
                    transform: `scale(${isHovered ? 1.15 : 1})`,
                    transition: "transform 0.3s ease",
                    transformOrigin: "center center",
                  }}
                >
                  <CardContainer
                    hexagenUid={hexagenUid}
                    withZoom={false}
                    disableAppearAnimation={true}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
